var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React from 'react';
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { getPasswordField, getPasswordConfirmField } from '@eva-pacs/core';
import { passwordrecoveryformClass } from './styles';
import { Button, ButtonType, FormField, PasswordInput } from '../..';
/**
 * Describe PasswordRecoveryForm usage.
 * @author Alejo Forero<alejoforero.af@gmail.com>
 * Created at 2021-06-08
 */
export var PasswordRecoveryForm = function (_a) {
    var className = _a.className, onSuccess = _a.onSuccess, _b = _a.isLoading, isLoading = _b === void 0 ? false : _b;
    var t = useTranslation().t;
    var schema = yup.object().shape({
        password1: getPasswordField(t),
        password2: getPasswordConfirmField(t),
    });
    var _c = useForm({
        criteriaMode: 'all',
        mode: 'all',
        resolver: yupResolver(schema),
    }), control = _c.control, handleSubmit = _c.handleSubmit, _d = _c.formState, errors = _d.errors, isValid = _d.isValid;
    var onSubmit = function (data) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, onSuccess(data)];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    return (React.createElement("form", { className: passwordrecoveryformClass(className), onSubmit: handleSubmit(onSubmit) },
        React.createElement(FormField, { className: "mb-6", name: "password1", defaultValue: "", label: t('auth.formFields.newPassword'), control: control, error: errors.password1, render: function (_a) {
                var field = _a.field;
                return (React.createElement(PasswordInput, { id: field.name, name: field.name, value: field.value, onChange: field.onChange, placeholder: t('auth.formFields.newPassword') }));
            } }),
        React.createElement(FormField, { className: "mb-4", name: "password2", defaultValue: "", label: t('auth.formFields.confirmNewPassword'), control: control, successMessage: isValid ? t('auth.passwordRecovery.form.success') : '', error: errors.password2, render: function (_a) {
                var field = _a.field;
                return (React.createElement(PasswordInput, { id: field.name, name: field.name, hasError: !!errors.password2, value: field.value, onChange: field.onChange, placeholder: t('auth.formFields.confirmNewPassword') }));
            } }),
        React.createElement(Button, { name: "submit", className: "mt-6", type: ButtonType.submit, isLoading: isLoading }, t('auth.passwordRecovery.form.submit'))));
};
